import { AnyTag, ContactTag, ConversationTag } from './types';

// eslint-disable-next-line no-shadow
export enum TagType {
  AGENT = 'AGENT',
  CONTACT = 'CONTACT',
}

// eslint-disable-next-line no-shadow
export enum ContactError {
  FETCH = 'fetch',
  CREATE = 'create',
  ASSIGNED_DELETE = 'assigned-delete',
  DELETE = 'delete',
  EDIT = 'edit',
  UNASSIGN = 'unassign',
}

// eslint-disable-next-line no-shadow
export enum ContactSuccess {
  CREATE = 'create',
  ASSIGNED_DELETE = 'assigned-delete',
  DELETE = 'delete',
  EDIT = 'edit',
}

export const getTagData = (tag: AnyTag): AnyTag => ({
  name: tag.name || tag.tagName || '',
  emoji: tag.emoji || '',
  active: tag.active,
  color: tag.color,
  tagId: tag.tagId || undefined,
  assigned: tag.assigned,
  conversionType: tag.conversionType,
});

export const getOldTagData = (tag: AnyTag): ConversationTag => ({
  tagName: tag.name || tag.tagName || '',
  emoji: tag.emoji || '',
  active: tag.active,
  color: tag.color,
  assigned: !!tag.assigned,
  botId: tag.botId || tag.tagId || -1,
  conversionType: tag.conversionType,
  ...(tag.conversionType === 'PURCHASE' && { purchase: tag.purchase }),
});

export function getTagName(tag: AnyTag) {
  return tag.name || tag.tagName || '';
}

export function getTagId(tag: AnyTag) {
  if ('tagId' in tag) return (tag as ContactTag).tagId;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return (tag as ConversationTag).tagName!;
}

export const WIDTH_CHATLIST = 450;
export const WIDTH_CONTEXT_MENU = 325;

export const positions = {
  under: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
  },
  left: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  },
  over: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  },
  overRight: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
  },
};

export const sortTags = (tags: AnyTag[]) => {
  if (!Array.isArray(tags)) {
    // eslint-disable-next-line no-console
    console.error('Provided "tags" param must be an array!');
    return [];
  }
  return tags.sort((a, b) => (getTagName(a) < getTagName(b) ? -1 : 1));
};

export default getTagData;
